
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EmployeeYearPanelInterface, UsedLeaveTypesCountsInterface } from '@/services/Calendar/leaves/interfaces';
import UpdateEmployeeLeavesDialog from '@/components/dialogs/calendar/leave/UpdateEmployeeLeavesDialog.vue';
import Themeable from 'vuetify/lib/mixins/themeable';
import { Roles } from '@/services/Roles';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    UpdateEmployeeLeavesDialog,
  },
})
export default class LeaveCountsComponent extends Vue {
  @Prop() private yearPanel!: EmployeeYearPanelInterface;
  @Prop() private usedLeaveTypes!: UsedLeaveTypesCountsInterface[];
  @Prop() private userId!: string;

  private showAllTypes: boolean = false;

  private userIdForDialog: string | false = false;
  private dialog: string = '';

  private descriptionDialog: boolean = false;
  private selectedTypeForDescription: UsedLeaveTypesCountsInterface | null = null;

  private get paidUsed(): number {
    return this.yearPanel.takenThisYear + this.yearPanel.bookedThisYear;
  }

  private userHasScopes(scope: string): boolean {
    return this.$store.getters.scopes.includes(scope);
  }

  private get canEditPaid(): boolean {
    return this.userHasScopes(Roles.CALENDAR_EMPLOYEE_UPDATE);
  }

  private get filteredTypes(): UsedLeaveTypesCountsInterface[] {
    if (this.showAllTypes) {
      return this.usedLeaveTypes;
    }
    return this.usedLeaveTypes.filter(t => t.count > 0);
  }

  private get currentYear(): number {
    return new Date().getFullYear();
  }

  private showDialog(): void {
    this.dialog = 'UpdateEmployeeLeavesDialog';
    this.userIdForDialog = this.userId;
  }

  private openDescriptionDialog(type: UsedLeaveTypesCountsInterface): void {
    this.selectedTypeForDescription = type;
    this.descriptionDialog = true;
  }
}
